import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";
import { Modules } from '../libs/utils/Const';

let headers = [
    {title: 'Nombre'}
];

class GroupNumModal extends Component {
    componentDidMount(): void {
        this.closeAction();
    }

    closeEmployee = async () => {
        $('#groupNumModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#groupNumModal').on('hidden.bs.modal', function () {
            //console.log("cerrar groupNumModal");
            cleanData();
        });
    };


    render() {
        const { data, selectGroupNum, showGroupNumModal } = this.props;

        if(data.length === 0){
            return <div className="modal fade bd-example-modal-lg bgtransparent"  role="dialog"  id="groupNumModal"></div>;
        }
        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll"  role="dialog"  id="groupNumModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Condiciones de Pago</h4>
                                <button type="button" className="close" onClick={this.closeEmployee} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table response" style={{marginBottom: 0}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers} view={"groupNumModal"} action={selectGroupNum} showGroupNumModal={showGroupNumModal}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer d-flex justify-content-between">
                                {(!!showGroupNumModal && Modules.PaymentTerms) ? <button type="button" className="btn botonCorrect" onClick={() => showGroupNumModal()}>Nuevo</button> : <div/>}
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeEmployee}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default GroupNumModal;